module.exports = function getResource(label, vars = []) {
    let resources = {
        shipInternationalText: 'Livraison à l’international',
        canadaCheckoutText: 'Passer à la caisse au Canada',
        unitedStatesCheckoutText: 'Passer à la caisse aux États-Unis',
        shippingToText: 'Expédier à',
        changeCountryText: 'Changer de pays'
    };

    return resources[label];
};
